module.exports = __webpack_public_path__ + "images/bug_purple_size_6_8a25ce9810946efce0bbf584222926d9.png";